/****************************************************
 * Module Name:  closeMemoModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import CancelIcon from '@mui/icons-material/Cancel';

function CloseMemoModal({
    show,
    setShow,
    handleSave,
    memoid,
    closeMemoModalTitle,
    loading,
}) {
    const [showError, setShowError] = useState(false);

    const saveHandler = () => {
        let message = "Memo Closed Successfully";
        if (handleSave) {
            handleSave(memoid, message);
        }
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    const handleClose = () => {
        setShow(false);
    };
    return (
        <div>
            <TabMenuSnackbar
                show={showError}
                message={
                    <Box>
                        Close Memo validation Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        Close Memo
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        {closeMemoModalTitle}
                    </Typography>
                </Modal.Body>
                <Modal.Footer>
                    <Box
                        sx={{
                            "& .Mui-disabled": {
                                backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                                color: "rgba(0, 0, 0, 0.26) !important"
                            }
                        }}
                    >
                        <LoadingButton
                            variant="contained"
                            onClick={saveHandler}
                            type="Submit"
                            sx={{ mr: 3 }}
                            loading={loading}
                            loadingPosition="start"
                            startIcon={<CancelIcon size="large" />}
                        >
                            Close Memo
                        </LoadingButton>
                    </Box>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        sx={{ mr: 2 }}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CloseMemoModal;
